import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';

import { HamodelModel } from '../../../model/index';
import { HamodelService, CommonService } from '../../../services/index';

@Component({
    selector: 'stock-in-tab',
    templateUrl: './stockIn.component.html',
})
export class StockinMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    //@Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];
    partyCtrl: FormControl;
    typeCtrl: FormControl;
    modelCtrl: FormControl;
    isLoadMask: Promise<any>;
    stockDet: HamodelModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    ModelList = [];
    typeList = [];
    actModelList = [];
    public isShow: boolean =true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'stock_id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService) {
        //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO
        function hasValidParty(input: FormControl) {
            let partyID = input.value, retVal = null;
            if (partyID == "") {
                retVal = { inValidParty: true };
            }
            if (partyID && typeof partyID === 'string') {
                retVal = { inValidParty: true };
            }
            return retVal;
        }
        this.partyCtrl = new FormControl('', [
            Validators.required,
            hasValidParty.bind(this)
        ]);
        this.filteredParty = this.partyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterParty(name) : this.PartyList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredModel = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterModel(name) : this.ModelList.slice());

         //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "HA Model" && ledgerID != "Spare" ) {
                retVal = { inValidType: true };
            }
          
            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);

        this.stockDet = [];
        this.stockDet['mode'] = 'Add';
    }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Party', prop: 'party_name', width: 200, minWidth: 200, maxWidth: 200, cellClass: 'cell-left' },
            { name: 'Type', prop: 'stock_type', cellClass: 'cell-left', width: 135, minWidth: 135, maxWidth: 135 },
            { name: 'Name', prop: 'name', cellClass: 'cell-left', width: 400, minWidth: 400, maxWidth: 400 },
            { name: 'Serial No', prop: 'serial_no', width: 200, minWidth: 200, maxWidth: 200, cellClass: 'cell-left' },
            { name: 'Qty', prop: 'act_qty', width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'MRP', prop: 'mrp', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center' }
        ];

        this.pageCallback({ offset: 0 });
        //TO LOAD PARTY LIST
        this.loadPartyList();
        //TO LOAD MODEL STOCK LIST
        this.loadStockModelList();
        this.typeList = ['HA Model', 'Spare'];
    }

    selectUserType(type:any) {
		if(type == 'Spare' ){
			this.isShow = false;
		}else{
			this.isShow = true;	
		}
    }
    loadPartyList() {
        let that = this;
        this.commonService
            .getPartyList()
            .then(function(res: any) {
                if (res.success) {
                    that.PartyList = res.data;
                    that.partyCtrl.setValue(that.stockDet['party_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadStockModelList() {
        let that = this,
            data = {
                type: 'All',
                comp_stock: 'No'
            };
        this.commonService
            .getStockModelList(data)
            .then(function(res: any) {
                if (res.success) {
                    that.actModelList = res.data;
                    //that.ModelList = res.data;
                    //that.modelCtrl.setValue(that.stockDet['model_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    onSelectedType(typeName) {
        this.ModelList = [];
        this.ModelList = _.filter(this.actModelList, { 'from_page': typeName });
        this.modelCtrl.setValue(this.stockDet['model_id']);
    }
    filterParty(name: string) {
        name = _.escapeRegExp(name);
        return this.PartyList.filter(item => (new RegExp(name, 'gi').test(item.party_name)));
    }

    displayPartyFn(partyID: number) {
        if (partyID && this.PartyList.length > 0) {
            let fitem = _.find(this.PartyList, { 'party_id': partyID });
            return fitem['party_name'];
        }
        return '';
    }

    filterModel(name: string) {
        name = _.escapeRegExp(name);
        return this.ModelList.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }

    displayModelFn(modelID: number) {
        if (modelID && this.ModelList.length > 0) {
            let fitem = _.find(this.ModelList, { 'model_id': modelID });
            return fitem['name'];
        }
        return '';
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
            this.page.offset = pageInfo.offset;
            this.getStockList();
        
    }

    /**
   * Called whenever the user changes the sort order
   */
/*     sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getStockList();
    } */
    onScroll() {
        this.suppressPaging = true;

        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getStockList();
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getStockList();
    }
    getStockList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.hamodelService
            .getStockList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.stockList = res.data;
            });
    }

    public onEditStock(row: any): void {
        // let that = this;
        // setTimeout(function() {
        //     that.filterPanel.close();
        // }, 10);
        // this.bsModalRef = this.modalService.show(AddEditPurchasePartyComponent, {
        //     keyboard: false,
        //     ignoreBackdropClick: true
        // });
        this.onSelectedType(row['stock_type']);
        row['mode'] = 'Edit';
        // this.bsModalRef.content.title = mode + ' Purchase Party Details';
        // this.bsModalRef.content.purParData = Object.assign({}, row);
        // this.bsModalRef.content.purchasePartyLoadEvent.subscribe(($e) => {
        //     that.getStockList();
        // });
        this.stockDet = [];
        this.stockDet = Object.assign({}, row);
    }

      onReset(): void {

      this.stockDet = [];
      this.stockDet['mode'] = 'Add';


    }
    onSaveStock(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };
        if (this.stockDet['stock_type'] == 'HA Model') {
            if (this.stockDet['act_qty'] != '1') {
                toast['body'] = 'Quantity Can not be Greater than 1';
                this.toasterService.pop(toast);
                return;
            }
            if(_.isEmpty(this.stockDet['serial_no'])){
                toast['body'] =  'Please Enter Serial No';
                this.toasterService.pop(toast);
                return;
            }
        }
        let that = this,
            data = {
                mode: this.stockDet['mode'],
                party_id: this.stockDet['party_id'],
                model_id: this.stockDet['model_id'],
                qty: this.stockDet['act_qty'],
                mrp: this.stockDet['mrp'],
                stock_type: this.stockDet['stock_type'],
                serial_no: this.stockDet['serial_no'],
                stock_id: this.stockDet['stock_id']
            };
        this.isLoading = true;
        this.hamodelService
            .addUpdateStockDetails(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                   // that.stockDet = [];
                    swal('SUCCESS', res.message, 'success');
                     that.onReset();
                    that.getStockList();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    onDeleteStock(row: any): void {
        let that = this,
            data = {
                stock_id: row.stock_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover: ' + row.name + ' Stock Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.hamodelService
                .deleteStock(data)
                .then(function(res: any) {
                    if (res.success) {
                        that.getStockList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/stockIn/stockIn.component.ts